const data = [
  { title: 'Head Office', email: 'info@chachanlath.in', phone: ['+91-11 46461616', '+91-11 46461617'],
   items: [
    '1308- 09, Best SkyTower,',
    'F-5, Netaji Subhash Place,',
    'Pitampura, Delhi-110034, India',
  ]},

];
export default data;



// WEBPACK FOOTER //
// ./src/ContactPage/data.js